export const AppVentFDAdapterOnChange = "fd:adapter:on-change";
export const AppVentFDAdapterTestConnectionStatus = "fd:adapter:connection-status";
export const AppVentFDAdapterConnectionFieldsChanged = "fd:adapter:connection-fields-changed";
export const AppVentFDAdapterConnectionFieldsRevert = "fd:adapter:connection-fields-revert";
export const AppVentFDAdapterProviderTypeChanged = "fd:adapter:provider-type-changed";
export const AppVentFDAdapterHandlerTypeChanged = "fd:adapter:handler-type-changed";
export const AppVentFDAdapterUseCPChanged = "fd:adapter:use-cp-changed";
export const AppVentFDAdapterCPChanged = "fd:adapter:cp-changed";
export const AppVentVtsDependencyFieldsChanged = "fd:vts:dependency-fields-changed";
